import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data); 
export const getAdditionalList = (data) => Ajax.post('account/getAdditionalList',data); 
export const getAdditionalIncentiveList = (data) => Ajax.post('account/getAdditionalIncentiveList',data); 
export const addStaffAdditionalPayment = (data) => Ajax.post('account/addStaffAdditionalPayment',data); 
export const updateStaffAdditionalpayment = (data) => Ajax.post('account/updateStaffAdditionalpayment',data);
export const removeStaffAdditional = (data) => Ajax.post('account/removeStaffAdditional',data);
export const getAdditionalPaymentById = (data) => Ajax.post('account/getAdditionalPaymentById',data);

